import { GeoBoundsDTO } from './geo-bounds.dto';
import { FilterDTO } from './filter.dto';

export class AreaSearchMapDTO {
  constructor(public readonly bounds: GeoBoundsDTO,
              public readonly reportFilter: FilterDTO) {
  }
}
